import { useEffect } from 'react'
import { useGetChalcoReport } from '@/shared/hooks/api/integrations'
import MesReportEmbed from '@/features/mes-integration/components/MesReportEmbed'
import MesReportEmbedZh from '@/features/mes-integration/components/MesReportEmbed.zh'
import { useParams } from 'react-router-dom'

export default function MesIntegrationReportPdf() {
  const { id } = useParams()
  const { data: chalcoReport, isPending } = useGetChalcoReport(id!)

  useEffect(() => {
    document.body.style.setProperty('background-color', 'white')
  }, [])

  if (isPending) {
    return null
  }

  if (!chalcoReport) {
    return null
  }

  if (chalcoReport.data.locale?.includes('zh')) {
    return (
      <MesReportEmbedZh
        data={chalcoReport.data}
        startDate={chalcoReport.startDate}
        endDate={chalcoReport.endDate}
        organization={chalcoReport.installation.organization}
        installation={chalcoReport.installation}
        productionRoute={chalcoReport.productionRoute}
      />
    )
  }

  return (
    <MesReportEmbed
      data={chalcoReport.data}
      startDate={chalcoReport.startDate}
      endDate={chalcoReport.endDate}
      organization={chalcoReport.installation.organization}
      installation={chalcoReport.installation}
      productionRoute={chalcoReport.productionRoute}
    />
  )
}
